import { store, getContext } from '@wordpress/interactivity';

import { LOCAL_STORAGE_KEY } from '../../settings.js';

const { callbacks, state } = store('mediapress-polls', {
  state: {
    get totalVotes() {
      const context = getContext();
      return Object.values(context.count).reduce((carry, current) => carry + current, 0);
    },
  },
  callbacks: {
    /**
     * Retrieves the user's votes from local storage.
     *
     * @return {Array} Array of votes from local storage
     */
    getLocalVotes: () => {
      const userVotes = localStorage.getItem(LOCAL_STORAGE_KEY);
      return JSON.parse(userVotes) || [];
    },
    /**
     * Checks if the user has already voted in the poll.
     *
     * @return {void}
     */
    *checkUserHasVoted() {
      const context = getContext();
      const { pollId } = context;

      const existingVotes = callbacks.getLocalVotes();

      const existingVote = existingVotes.find((vote) => vote.pollId === pollId);
      if (!existingVote) {
        return;
      }

      const { optionId, totalVotes } = existingVote;

      context.selectedOptionId = optionId;
      yield callbacks.updatePollCount();
      if (state.totalVotes <= totalVotes) {
        context.count[optionId] = (context.count[optionId] ?? 0) + 1;
      }

      context.showResult = true;
    },
    /**
     * Update Poll Count with the latest from the server.
     */
    *updatePollCount() {
      const context = getContext();
      const result = yield fetch(
        `${state.apiRoot}/poll/${context.pollId}/results${context.forceRefresh ? `/${Date.now()}` : ''}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )
        .then((res) => res.json())
        .catch((err) => console.error(err.message)); // eslint-disable-line no-console

      const options = Object.values(context.options);

      // filter count to remove unavailable options
      context.count = Object.fromEntries(
        Object.keys(result)
          .filter((optionId) => options.includes(optionId))
          .map((optionId) => [optionId, result[optionId]]),
      );
    },
  },
});
